// Copyright (c) 2021-2025 Broadcom. All Rights Reserved.
// Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
// and/or its subsidiaries.

import { CspEnvironment } from "@vmw/csp-ngx-components";
import { AppConfig, CSP_SESSION_STORAGE_METHOD, CSP_STAGING_HOST, Feature, ServiceState } from "@app/services/app-config/model";
import { ServiceTypeEnum } from "@api/generated/vcdr";
import { ConsoleType } from "@shared/models/global.model";

export const environment: AppConfig = {
    production: false,
    vipHost: "https://csp-stg.broadcom.com",

    opConsoleOrgId: "2fabb77d-7829-44ad-a9da-61f1591f3d50",
    opConsoleApiServer: "https://vcdrsp-stg.vdp-int-stg.vmware.com",
    opConsoleClientId: "rRGGxm6yx72NGpIZ0FV4hQ10rpsmOdYX1Mk",
    opConsoleServiceId: "a8810000-4bcb-4718-a4cc-5ad12e0720fd",

    selfServiceApiServer: "https://vcdrsp-stg.vdp-int-stg.vmware.com",

    services: new Map(
        [
            [ServiceTypeEnum.VCDR, {
                serviceState: ServiceState.ENABLED_SELF_SERVICE,
                clientId: "NXy7Pd1wr6XIde4V0pCo3Y6FWM2mvcMttEg",
                serviceId: "d90e5b5f-5a94-4c6b-b233-ea3973b4c045",
                selfServiceConsole: ConsoleType.VLR,
                features: [Feature.SUBSCRIPTION_CHARTS,
                           Feature.DEPLOYMENT_FILTERS]
            }],
            [ServiceTypeEnum.VMCFS, {
                serviceState: ServiceState.ENABLED_SELF_SERVICE,
                clientId: "U8giPngJ7l3eKzg4PiaMxFEM0jPxoJedml6",
                serviceId: "a6537e81-b1d4-43e6-bc7e-0291581ebb43",
                selfServiceConsole: ConsoleType.VMCFS,
                features: [Feature.SUBSCRIPTION_CHARTS]
            }]
        ]),

    cspServiceId: "a8810000-4bcb-4718-a4cc-5ad12e0720fd",
    cspEnvironment: CspEnvironment.STAGING,

    // Here is where you configure your OAuth2 client for this environment. For this to work properly,
    // your CSP Service Org will need to issue its own public OAuth2 clients with appropriate scopes,
    // to be updated below.
    cspOAuthConfig: {
        // Your public client ID.
        clientId: "NXy7Pd1wr6XIde4V0pCo3Y6FWM2mvcMttEg",//'ngx_public_client',
        // Options: 'local' or 'session'.
        storage: CSP_SESSION_STORAGE_METHOD,
        scopes: [
            // A list of all scopes which this client should request. Note that
            // what the client requests, what the client configuration permits, and
            // what the service exposes all must align. Leaving this list empty
            // will request all available scopes.
            // 'csp:org_member'
        ],
        cspHostname: CSP_STAGING_HOST,

        resourceServers: [
            // A list of http://resources.servers that support the OAuth2 Authorization header for
            // authorization. These are not the same as the CSP hostname.
            { matcher: new RegExp(/^.*(resources\/).*/mg), optional: true }
        ],
        requiredScopes: [
            // A list of the above scopes that are required for service access.
            //'csp:org_member',
            //'csp:org_owner',
            //'csp:cross_org_operator',
            //'csp:service_owner'
        ],
        tokenExpirationBuffer: 20
    }
};
